import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

import type { FC } from 'react'

type Before2025Props = {
  children: React.ReactNode
  childrenFallback?: React.ReactNode | null
}

const Before2025: FC<Before2025Props> = ({
  children,
  childrenFallback = null,
}) => {
  const { periodYear } = usePeriodContext()
  if (periodYear <= 2024) return <>{children}</>

  return <>{childrenFallback}</>
}

export default Before2025
